import { emptyFragment } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import * as React from 'react';
import { programsStore } from '../../../ProgramsStore';
import {
  currentProgramResource,
  currentProgramSequenceResource,
  visibleProgramResource,
} from '../../../ProgramsStore/Functions';
import { T } from '../../../Translations';
import NoActiveEnrollment from '../ProgramDashboard/NoActiveEnrollment';
import ProgramDashboards from '../ProgramDashboard/ProgramDashboards';
import * as style from '../style.module.css';

const ActivePrograms: React.FC<{}> = () => {
  return (
    <div className={style.active} data-test-active-programs={true}>
      {programsStore.resource
        .map(({ payload }) =>
          payload.programs.filter(currentProgramSequenceResource).filter(visibleProgramResource),
        )
        .andThen(fromArrayMaybe)
        .map((programs) => (
          <>
            <h2
              className="ml-2"
              data-test-active-learning-journey-title="Your Learning Journey"
              tabIndex={0}
            >
              <T kind="Your learning journey" />
            </h2>
            <ProgramDashboards programs={programs} />
          </>
        ))
        .getOrElse(emptyFragment)}
      {programsStore.resource
        .map(({ payload }) =>
          payload.programs.filter(currentProgramResource).filter(visibleProgramResource),
        )
        .andThen(fromArrayMaybe)
        .map((programs) => <ProgramDashboards programs={programs} />)
        .getOrElse(() => (
          <NoActiveEnrollment />
        ))}
    </div>
  );
};

export default observer(ActivePrograms);
